<forge-autocomplete #autocomplete allowUnmatched="true" filterFocusFirst="false" [filter]="autocompleteFilter"
                    (forge-autocomplete-change)="onSelectedItemChange($event)" [filterText]="filterText">
    <forge-text-field show-clear density="small" class="app-bar-search">
        <input type="text" id="txtGlobalSearch" tabindex="0" placeholder="Search" (keydown)="onKeydown($event)"
               aria-label="app bar search">
    </forge-text-field>
</forge-autocomplete>
